<script setup lang="ts">
const about = await queryContent('/about').findOne()
</script>

<template>
  <section id="about-section" class="about-event">
    <div class="container">
      <h2 class="about-event__title text-40">
        {{ about.title }}
      </h2>
      <div class="about-event__row">
        <div v-for="(item, index) in about.list" :key="index" class="about-event__card event-card">
          <div class="event-card__img-wrapper">
            <NuxtImg
              class="event-card__img"
              :src="item.image"
              :alt="item.title"
              loading="lazy"
              format="webp"
            />
          </div>
          <p class="event-card__text text-22">{{ item.title }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.about-event {
  padding-top: 68px;
  padding-bottom: 68px;
  background-color: var(--bg-grey);

  @media (max-width: $large) {
    padding-top: 56px;
    padding-bottom: 56px;
  }

  @media (max-width: $small) {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  @media (max-width: $mobile) {
    padding-top: 36px;
    padding-bottom: 36px;
    background-color: white;
  }

  &__title {
    margin-bottom: 89px;

    @media (max-width: $large) {
      margin-bottom: 56px;
    }

    @media (max-width: $small) {
      margin-bottom: 36px;
    }
  }

  &__row {
    display: grid;
    gap: 15px;
    grid-template-columns: repeat(4, 1fr);

    @media (max-width: $small) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: $mobile) {
      grid-template-columns: repeat(1, 1fr);
      gap: 12px;
    }
  }
}

.event-card {
  border-radius: 30px;
  padding: 0 56px 60px 56px;
  position: relative;

  @media (max-width: $large) {
    padding: 0 32px 41px 32px;
  }

  @media (max-width: $small) {
    padding: 22px 24px 40px;
  }

  @media (max-width: $mobile) {
    display: flex;
    align-items: center;
    gap: 26px;
    padding: 16px 16px 16px 22px;
    border-radius: 8px;
  }

  &__text {
    color: white;
    position: relative;
    margin-top: 14px;

    @media (max-width: $small) {
      margin-top: 33px;
    }

    @media (max-width: $mobile) {
      margin-top: 0;
    }
  }

  &__img-wrapper {
    position: relative;
    height: 245px;
    display: flex;
    align-items: center;

    @media (max-width: $large) {
      height: 180px;
    }

    @media (max-width: $small) {
      height: 140px;
    }

    @media (max-width: $mobile) {
      flex: 0 0 100px;
      height: 100px;
    }
  }

  &__img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &::before {
    content: '';
    position: absolute;
    width: 230px;
    height: 230px;
    border-radius: 100%;
    filter: blur(60px);
    left: 50%;
    top: 38px;
    transform: translateX(-50%);

    @media (max-width: $large) {
      width: 180px;
      height: 180px;
    }

    @media (max-width: $mobile) {
      width: 100px;
      height: 100px;
      left: initial;
      transform: initial;
    }
  }

  &:nth-child(1) {
    background-color: var(--success-color);

    &::before {
      background-color: #B3FFDF;
    }
  }

  &:nth-child(2) {
    background-color: var(--primary-color);

    &::before {
      background-color: #B3D2FF;
    }
  }

  &:nth-child(3) {
    background-color: var(--info-color);

    &::before {
      background-color: #B3EDFF;
    }
  }

  &:nth-child(4) {
    background: linear-gradient(227.11deg, #7F74FF 0%, #749BFF 50.5%, #75CCC2 100%);

    .event-card__img {
      @media (min-width: $large) {
        height: 90%;
      }
    }

    &::before {
      background-color: #B3EDFF;
    }
  }
}
</style>
